 // Function to check if the user has already subscribed using cookies
function checkCookie() {
    const popupDisplayed = getCookie("popupDisplayed");
    if (popupDisplayed === "true") {
        return true; // Do not show the popup again if cookie is set
    }
    return false;
}

// Function to get the value of a cookie by name
function getCookie(name) {
    let cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
        let cookie = cookieArr[i].trim();
        if (cookie.indexOf(name + "=") == 0) {
            return cookie.substring(name.length + 1, cookie.length);
        }
    }
    return "";
}

// Function to set a cookie with a specified name, value, and expiration time (in days)
function setCookie(name, value, days) {
    let d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

// Function to show the popup
function showPopup() {
    const popup = document.getElementById("sds-newsletter-popup");
    popup.style.display = "flex";
}

// Function to close the popup
function closePopup() {
    const popup = document.getElementById("sds-newsletter-popup");
    popup.style.display = "none";
}

// Event listener for the close button
document.getElementById("sds-close-btn").addEventListener("click", closePopup);

// Event listener for the subscribe button
document.getElementById("sds-subscribe-btn").addEventListener("click", function() {
    const email = document.getElementById("sds-email").value;
    if (email) {
        // Save email to your system (e.g., store in a database or email service)
        alert("Thank you for subscribing!");
        // Set a cookie to prevent the popup from showing for 30 days
        setCookie("popupDisplayed", "true", 30);
        closePopup();
    } else {
        alert("Please enter a valid email address.");
    }
});

// Function to show the popup with fade-in effect
function showPopup() {
    const popup = document.getElementById("sds-newsletter-popup");
    popup.style.display = "flex"; // Make the popup visible
    setTimeout(function() {
        popup.classList.add("show"); // Trigger the fade-in effect
    }, 10); // Slight delay to allow the display change to be registered
}

// Function to close the popup with fade-out effect
function closePopup() {
    const popup = document.getElementById("sds-newsletter-popup");
    popup.classList.remove("show"); // Trigger the fade-out effect
    setTimeout(function() {
        popup.style.display = "none"; // Hide the popup after fade-out
    }, 500); // Wait for the fade-out transition to complete before hiding
}

// Show the popup after 5 seconds if not already displayed (based on cookies)
setTimeout(function() {
    if (!checkCookie()) {
        showPopup();
    }
}, 5000);

// Detect exit intent to show the popup when the user tries to leave
let hasShownExitIntent = false;

document.addEventListener("mouseout", function(e) {
    if (!hasShownExitIntent && e.clientY < 50) {
        hasShownExitIntent = true;
        if (!checkCookie()) {
            showPopup();
        }
    }
});

// Function to close the popup if the user clicks outside the popup content
function closePopupOnClickOutside() {
    const popup = document.getElementById("sds-newsletter-popup");
    const popupContent = document.querySelector(".sds-popup-content");

    // Add an event listener to detect clicks on the document
    document.addEventListener("click", function(event) {
        // Check if the click happened outside the popup content
        if (!popupContent.contains(event.target) && popup.style.display === "flex") {
            popup.style.display = "none"; // Close the popup
        }
    });
}

// Call the function to enable the click-outside functionality
closePopupOnClickOutside();
